import {
    Stack,
    Box,
    Text,
    Image,
    Flex,
    Spinner
} from '@chakra-ui/react'
import ErrorPage from '../error-page'
import styled from 'styled-components'
import { colors } from 'src/common/colors'
import { SVG } from '../../common/svg'
import useGetPlayerDetails from 'src/hooks/SearchInfo/useGetPlayerDetails'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { formatStartDate, formatActivityDate } from '../../common/util'

export default function PlayerDetails() {
    const { playerId } = useParams<{ playerId: string }>()
    const { getPlayerDetails, child, playerDetailsError } = useGetPlayerDetails()

    useEffect(() => {
        if (playerId) {
            getPlayerDetails(playerId)
        }
    }, [playerId])

    const genderChange = (genderEng: string) => {
        if (genderEng === 'FEMALE') {
            return '여자'
        } else if (genderEng === 'MALE') {
            return '남자'
        }
    }

    function formatPhoneNumber(phoneNumber: string) {
        const numericOnly = phoneNumber.replace(/\D/g, '')
        const formattedNumber = numericOnly.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
        return formattedNumber
    }

    return (
        <Container>
            {(playerId && child) ?
                <>
                    <Flex direction='column' marginBottom='55px'>
                        <Text fontSize='22px' color={colors.darkBlue} fontFamily='KFAGothicBold' marginBottom='36px'>검색 결과 상세</Text>
                        <Flex alignItems='center'>
                            <Flex
                                width='161px'
                                height='161px'
                                border={`3px solid ${colors.button.blue}`}
                                borderRadius='50%'
                                overflow='hidden'
                                marginRight='42px'
                                alignItems='center'
                                justifyContent='center'
                            >
                                <Image
                                    className="logo"
                                    width='100%'
                                    height='100%'
                                    objectFit='cover'
                                    src={child.childrenImageUrl}
                                    alt={child.childrenName}
                                />
                            </Flex>
                            <Flex direction='column' gap='10px'>
                                <Text fontFamily='NanumSquareNeoEBold' fontSize='24px' color={colors.darkBlue} lineHeight='162%'>{child.childrenName}</Text>
                                <Text fontSize='16px' color={colors.darkBlue} lineHeight='162%'>생년월일 | 성별 : {child.birthDay} | {genderChange(child.gender)}</Text>
                                <Text fontSize='16px' color={colors.darkBlue} lineHeight='162%'>소속 : {child.academyName}</Text>
                                <Text fontSize='16px' color={colors.darkBlue} lineHeight='162%'>연락처 : {formatPhoneNumber(child.phoneNumber)}</Text>
                            </Flex>
                        </Flex>
                    </Flex>
                    <Stack>
                        <Box borderBottom='1px solid rgba(19, 28, 77, 0.28)' marginBottom='44px'>
                            <Text
                                color={colors.darkBlue}
                                fontSize='18px'
                                padding='0 0 16px 14px'
                                borderBottom={`3px solid ${colors.button.blue}`}
                                width='101px'
                                fontFamily='KFAGothic'
                            >
                                활동 정보
                            </Text>
                        </Box>
                        <Flex direction='column' color={colors.darkBlue} marginBottom='38px'>
                            <Text fontFamily='KFAGothicBold' fontSize='22px' color={colors.darkBlue} fontWeight='700' marginBottom='29px'>활동 정보</Text>
                            <Text fontSize='16px' marginBottom='23px'>활동 시작일: {formatStartDate(child.activityStart)}</Text>
                            <Text fontSize='16px'>현재 챌린지 레벨: {child.level}</Text>
                        </Flex>
                        <Stack>
                            <Flex justifyContent='space-between' marginBottom='14px'>
                                <Text fontFamily='KFAGothic' fontSize='15px' color='rgba(19, 28, 77, 0.68)'>최신 활동순</Text>
                                <Image
                                    src={SVG.filter}
                                    alt="필터"
                                    position='relative'
                                    right='0'
                                    width='24px'
                                    height='24px'
                                    flexShrink='0'
                                    opacity='0.68'
                                    cursor='pointer'
                                />
                            </Flex>
                            <Flex flexWrap='wrap' justifyContent='space-between'>
                                {child.activities.map((program, i) => (
                                    <Flex
                                        key={i}
                                        width='49%'
                                        height='106px'
                                        marginBottom='21px'
                                        padding='31px 0 30px 28px'
                                        border='1px solid rgba(19, 28, 77, 0.15)'
                                        borderRadius='8px'
                                        direction='column'
                                        justifyContent='center'
                                        gap='10px'
                                    >
                                        <Text fontFamily='NanumSquareNeoEBold' fontSize='21px' color='#141E53' lineHeight='18px'>{program.activityName.replace(/_/g, ' ')}</Text>
                                        <Text fontSize='16px' color={colors.button.blue} lineHeight='18px'>{formatActivityDate(program.activityDate)}</Text>
                                    </Flex>
                                ))}
                            </Flex>
                        </Stack>
                    </Stack>
                </>
                :
                !playerId ?
                    <Text color={colors.darkBlue}>Player ID not found</Text>
                    :
                    playerDetailsError ?
                        <Box>
                            <ErrorPage />
                        </Box>
                        :
                        <Box>
                            <Spinner />
                        </Box>
            }
        </Container>
    )
}

const Container = styled.div`
    width: calc(100vw - 506px);
    min-width: 850px;
    font-family: KFAGothic;
    margin-right: 92px;
`